// extracted by mini-css-extract-plugin
export var observe = "Observe-module--observe--d78a6";